import { render, staticRenderFns } from "./SintomasPirosis.vue?vue&type=template&id=d2d4042c"
import script from "./SintomasPirosis.vue?vue&type=script&lang=js"
export * from "./SintomasPirosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports